import { gsap } from 'gsap';
import * as PIXI from 'pixi.js';
import { PixiPlugin } from 'gsap/PixiPlugin';
import { TextPlugin } from 'gsap/TextPlugin';

import { Spine } from '../../core/classes/spine';
import { isMobile } from '../../core/helpers/isMobile';

import { gameStore } from '../../store/gameStore';

import { WinningLinesCoordinate100 } from '../../gameConstants';

class GameResourcesService {
  allLinesSpine = [];

  allWinLinesBone = [];

  dustSpine = null;

  shakeSpine = null;

  winCoinSpine = null;

  expandWildSpine = null;

  winLineTimeOutId = null;

  winAmountTexture = null;

  setDustSpine(spine) {
    this.dustSpine = spine;
  }

  setShakeSpine(spine) {
    this.shakeSpine = spine;
  }

  setupPixiPlugins() {
    gsap.registerPlugin(PixiPlugin);
    gsap.registerPlugin(TextPlugin);
    PixiPlugin.registerPIXI(PIXI);
  }

  setWinAmountTexture(texture) {
    this.winAmountTexture = texture;
  }

  setExpandWildSpine(spine) {
    this.expandWildSpine = spine;
  }

  setWinCoinSpine(spine) {
    this.winCoinSpine = spine;
  }

  setupAllLine(parentContainer) {
    [...WinningLinesCoordinate100, ...WinningLinesCoordinate100].forEach((_, i) => {
      const winLine = new Spine({ key: 'winLine' });
      const reverseStartPossession = isMobile() ? 496 : 965;
      winLine.x += i + 1 > 100 ? reverseStartPossession : 0;
      this.allLinesSpine.push(winLine);
      parentContainer.addChild(winLine);
    });
    this.allWinLinesBone = this.allLinesSpine.map((el) =>
      el.skeleton.bones
        .filter((bone) => {
          return bone.data.name.includes('bone');
        })
        .sort((a, b) => (a.x > b.x ? 1 : b.x > a.x ? -1 : 0))
    );
  }

  resetAllLineSpine() {
    this.allLinesSpine.forEach((line) => {
      line.stop();
    });
    clearTimeout(this.winLineTimeOutId);
  }

  resetExpandWildSpine() {
    this.expandWildSpine.forEach((wild) => {
      gameStore.setIsExpandWildOpen(false);
      wild.isOpen = false;
      wild.stop();
    });
  }
}

export const gameResourcesService = new GameResourcesService();
